export const openErrorAlert = state => state.openErrorAlert;
export const errorText = state => state.errorText;
export const openWarningAlert = state => state.openWarningAlert;
export const warningText = state => state.warningText;
export const progress = state => state.progress;
export const multiProgress = state => state.multiProgress;
